import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import { Button, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import LoanValues from '../common/loanValues';
import PointOfContactCard from '../common/pointOfContactCard';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useLoanStore } from '@roc/feature-loans';
import { useDrawsStore } from '../hooks';
import { DrawRequestFormShared } from '../drawRequestForm/drawRequestFormShared';
import PreferredProcessCard from '../common/preferredProcessCard';
import { MobileSnapDrawAlert } from '../drawDetails/mobileSnapDrawAlert';
import AddPointOfContactCard from '../common/AddPointOfContactQuestion';
import DrawTypeSelection from '../common/drawSubTypeSelection';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useBaseStore } from '@roc/feature-app-core';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: 24,
  },
  buttonContainer: {
    marginTop: 36,
  },
}));

export const DrawRequestShared = observer(({ setShowSuccessScreen, showStartDrawRequestButton=true, showInsuranceType=false }) => {
  const {
    loanStore: { loanDetails },
  } = useLoanStore();
  const { drawRequestStore } = useDrawsStore();
  const { loanStore } = drawRequestStore
  const { globalStore } = useBaseStore();
  const {
    pointOfContactFormStore,
    isMobileSnapDrawSelected,
  } = drawRequestStore.pointOfContactStore;
  const classes = useStyles();
  const { loanRoutesConfig } = useLoanRoutes();
  const { push } = useHistory();
  const [
    openDrawRequestFormModal,
    setOpenDrawRequestFormModal,
  ] = useState<boolean>(false);

  const handleStartDrawRequest = async () => {
    drawRequestStore.successLoad = false;


    pointOfContactFormStore.runFormValidationWithMessage();
    if (pointOfContactFormStore.form.meta.isValid) {
      await drawRequestStore.submitRequest();
      if (drawRequestStore.successLoad) {
        if (drawRequestStore.isSowAvailable) {
          setOpenDrawRequestFormModal(true);
        } else {
          setShowSuccessScreen(true);
        }
      }
    }
  };

  const handleSubmit = () => {
    drawRequestStore.submitForm(drawRequestStore.drawStore.currentDraw.drawId);
    setOpenDrawRequestFormModal(false);
    push(
      loanRoutesConfig
        .loans(loanStore.loanDetails?.loanId)
        .children.draws.url
    );
  };

  const handleClose = () => {
    setOpenDrawRequestFormModal(false);
    push(
      loanRoutesConfig
        .loans(loanStore.loanDetails?.loanId)
        .children.draws.url
    );
  };
  useEffect(() => {
    drawRequestStore.pointOfContactStore?.setForm();
  }, []);

  const handleSave = () => {
    drawRequestStore.saveForm(drawRequestStore.drawStore.currentDraw.drawId);
    setOpenDrawRequestFormModal(false);
    push(
      loanRoutesConfig
        .loans(loanStore.loanDetails?.loanId)
        .children.draws.url
    );
  };
  const isThirdParty = drawRequestStore?.pointOfContactStore?.pointOfContactFormStore?.form?.fields?.inspectionProcess.value === 'Third Party'
  const isInspectionProcessNotEmpty = !!drawRequestStore?.pointOfContactStore?.pointOfContactFormStore?.form?.fields?.inspectionProcess.value;
  const isSoftCostOnlyDraw = drawRequestStore.pointOfContactStore?.isSoftCostOnlyDraw;

  const shouldShowAddPointOfContactQuestion = !isThirdParty && !drawRequestStore.pointOfContactStore?.isSoftCostOnlyDraw && isInspectionProcessNotEmpty && isMobileSnapDrawSelected;

  const shouldDisabledSnap = loanStore?.loanDetails.borrowers?.some(
    (borrower) => borrower.isEligibleForSnapDraws === false
  );
  const isDiscountedDraw = loanStore?.loanDetails.borrowers?.some(
    (borrower) => borrower.isDiscountedDraw === true
  );

  return (
    <>
      {isDiscountedDraw && globalStore.isInternalPortal && (
        <Box pb={2}>
          <Alert severity="error">
            <AlertTitle>
              <strong>Discounted draw</strong>
            </AlertTitle>
            This borrower is eligible for the discounted draw category. Please ensure the fees are changed accordingly as per the new guidelines.
          </Alert>
        </Box>
      )}
      {isMobileSnapDrawSelected && (
        <Box pb={2}>
          <MobileSnapDrawAlert
            isMobileDraw={isMobileSnapDrawSelected}
            investor={null}
            lenderId={loanDetails?.lenderId}
          />
        </Box>
      )}
      <Grid container direction="row" spacing={3}>
        {shouldDisabledSnap && (
          <Grid item xs={12}>
            <Alert severity="warning">
              This loan does not qualify for Snap Draws
            </Alert>
          </Grid>
        )}
        <Grid item container direction="row" spacing={3}>
          <DrawTypeSelection showInsuranceType={showInsuranceType} />
          <LoanValues />
          {!isSoftCostOnlyDraw && (
            <PreferredProcessCard shouldDisabledSnap={shouldDisabledSnap} />
          )}
          {shouldShowAddPointOfContactQuestion && (
            <AddPointOfContactCard loanDetails={loanDetails} />
          )}
          {(isInspectionProcessNotEmpty || isSoftCostOnlyDraw) && (
            <PointOfContactCard />
          )}
        </Grid>
        {showStartDrawRequestButton && (
          <Grid
            container
            item
            justifyContent="center"
            className={classes.buttonContainer}
          >
            <Grid item xs={12} md={3}>
              <Button
                variant="contained"
                size="small"
                onClick={handleStartDrawRequest}
                color="primary"
                testId="start_draw_request"
                fullWidth={true}
              >
                START DRAW REQUEST
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
      <StandardDialog
        open={openDrawRequestFormModal}
        title="Draw Request Form"
        maxWidth="xl"
        handleClose={handleClose}
        dialogContent={
          <DrawRequestFormShared
            onSubmit={handleSubmit}
            onSave={handleSave}
            store={drawRequestStore}
          />
        }
      />
    </>
  );
});
